import { FiSunset, FiImage, FiPercent, FiBook } from "react-icons/fi";
import { useParams } from "react-router-dom";
// import NavCard from "../../Partials/Layouts/NavCardList/NavCard/NavCard";
// import NavCardList from "../../Partials/Layouts/NavCardList/NavCardList";
import NavCard from "../../Partials/Layouts/NavCardList/NavCard/NavCard";
import NavCardList from "../../Partials/Layouts/NavCardList/NavCardList";

function SubcatSectionCardScreens() {

    const {subcategoryID} = useParams()
    return (
        <NavCardList numOfCards={'four_nav_cards_list'}>
            <NavCard cardName='Subcategory NDI Cards' navCardLink={'/subcategoryNDICards/' + subcategoryID}>
            <FiSunset />
            </NavCard>
            <NavCard cardName='Subcategory NI Cards' navCardLink={'/subcategoryNICards/' + subcategoryID}>
            <FiImage />
            </NavCard>
            <NavCard cardName='Subcategory Stat Cards' navCardLink={'/subcategoryStatCards/' + subcategoryID}>
                <FiPercent />
            </NavCard>
            <NavCard cardName='Subcategory Sections' navCardLink={'/subcategorySections/' + subcategoryID}>
                <FiBook />
            </NavCard>
        </NavCardList>
    )
}

export default SubcatSectionCardScreens